import React, { useEffect, useRef, useState, useContext } from "react";
import "./Banner.css";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Pagination, Autoplay } from "swiper/modules";
import { Context } from "../../../utils/context";
import { AllVendors, Homebanner } from "../../../utils/apis/Home/Homeapi";
import Slider from "react-slick";
import Form from 'react-bootstrap/Form';
import Select from 'react-select'

// import required modules
import { EffectFade } from "swiper/modules";
import { allCategoryWithoutId, City, CityWithoutState } from "../../../utils/apis/master/Master";
import { Select2Data } from "../../../utils/api";
import { useNavigate } from "react-router-dom";
function Banner() {
  const navigate = useNavigate()
  const { IMG_URL, setSelectedCityID, selectedCityID, setselectedCategoryID, setsecondBreadCrum } = useContext(Context);
  const [data, setData] = useState();
  const [vendorData, setvendorData] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [vendorName, setVendorName] = useState();
  const [cityID, setCityID] = useState();
  const [selectedCategory, setSelectedCategory] = useState()
  const [selectedCategoryLabel, setselectedCategoryLabel] = useState()



  console.log("data", data)

  const getAllBannerData = async () => {
    const res = await Homebanner();
    if (res?.success) {
      setData(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };
  useEffect(() => {
    getAllBannerData();
    // getAllVendorData()
    // getCites()
    handleCityChange()
  }, []);

  console.log("cityOptions", cityOptions, vendorData)



  // const getAllVendorData = async () => {
  //   const res = await AllVendors();
  //   if (res?.success) {
  //     const datavendor = res?.data.map((data) => ({
  //       value: data?.id,
  //       label: data?.first_name,
  //       name: "vendor_id",
  //     }));

  //     console.log("datavendor", datavendor)
  //     setvendorData(datavendor);

  //   } else {
  //     console.error("Error fetching  data:", res?.error);
  //   }
  // };



  const handleVendorChange = async (e) => {
    const res = await AllVendors(e);
    if (res?.success) {
      const datavendor = res?.data.map((data) => ({
        value: data?.id,
        label: data?.first_name,
        name: "vendor_id",
      }));

      console.log("datavendor", datavendor)
      setvendorData(datavendor);
    }
    else {
      console.error("Error fetching  data:", res?.error);
    }
  };


  const [categoryOption, setCategoryOption] = useState([])

  const getCategories = async () => {
    const res = await allCategoryWithoutId()
    if (res?.success) {
      const data = await Select2Data(res?.data, "category_id", false)
      setCategoryOption(data)
    }
  }

  useEffect(() => {
    getCategories()
  }, [])





  const handleCityChange = async (e) => {
    const res = await CityWithoutState(e);
    if (res?.success) {
      const data = await Select2Data(res.data, "city_id", false);
      setCityOptions(data);
    }
    else {
      console.error("Error fetching  data:", res?.error);
    }
  };





  // const getCites = async () => {
  //   const res = await CityWithoutState();
  //   if (res?.success) {
  //     const data = await Select2Data(res.data, "city_id", false);
  //     setCityOptions(data);
  //   }
  // };







  const options = [
    { value: 'option1', label: 'Option 1' },
    { value: 'option2', label: 'Option 2' },
    { value: 'option3', label: 'Option 3' },
  ]


  const [error, setError] = useState("");

  const handleExploreClick = () => {
    if (!selectedCategory && !selectedCityID) {
      setError("Please select at least one: Category or Location.");
    } else {
      setError(""); // Clear error if validation passes
      exploreCategory();
    }
  };

  const exploreCategory = () => {

    console.log("categoryOption", categoryOption)

    // const cat_breadCrum = selectedCategoryLabel ? selectedCategoryLabel : categoryOption?.[0]?.label
    const cat_breadCrum = selectedCategoryLabel ? selectedCategoryLabel : "Services"

    setsecondBreadCrum(cat_breadCrum)

    let path = "/media-spaces";
    const category = selectedCategory || "";
    path += `/${category}`;

    if (cityID) {
      path += `&city_id=${cityID}`;
    }

    navigate(path);
  }

  return (
    <section className="container-fluid p-0">
      {data?.slice(-1)?.map((data, index) => (
        <div className=" home-banner-sec">
          <img className="bannerimg" src={IMG_URL + data?.image} />
          <div className="overlaycolor"></div>

          <div className="overlay-content">
            <div className="container ">

              <div className="row">
                <div className="col-md-10 mx-auto">

                  <div className="content">
                    <div className="titlediv">
                      <h2 className="maint">{data?.name}</h2>
                      <p className="submaint">{data?.sub_heading}</p>
                    </div>

                    <div className="row mt-2">
                      <div className="col-lg-7 mx-auto">
                        <Form>
                          <div className="searchdiv">
                            <div className="row">
                              <div className="col-sm-6">

                                {/* <input type="text" className="search_input" 
                                placeholder="Search For Category" 
                                onChange={((e) => setVendorName(e.target.value))} /> */}

                                <Select
                                  options={categoryOption}
                                  placeholder="Select For Category"
                                  onInputChange={(selectedOption) => {
                                    handleVendorChange(selectedOption);
                                  }}
                                  onChange={(e) => {
                                    setSelectedCategory(e?.value);
                                    setselectedCategoryID(e?.value)
                                    setselectedCategoryLabel(e?.label)
                                    setError("");
                                  }}
                                />

                              </div>
                              <div className="col-sm-6">
                                {cityOptions?.length > 0 && (
                                  <Select options={cityOptions}
                                    placeholder="Search Location"
                                    onChange={(e) => {
                                      console.log("setCityID", e)
                                      setCityID(e?.value);
                                      setSelectedCityID(e?.value)
                                      setError("");
                                    }}
                                  />
                                )}


                              </div>
                            </div>

                            <div className="submitdiv">
                              <button
                                className="submitbtn"
                                type="button"
                                onClick={() => {
                                  handleExploreClick()
                                }}
                              >
                                EXPLORE Category
                              </button>


                            </div>

                          </div>
                        </Form>
                        {error && (
                          <span className="invalid-feedback error_msg d-block" >
                            {error}
                          </span>
                        )}
                      </div>

                    </div>

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      ))}


    </section >
  );
}

export default Banner;
